import { Box, Stack } from '@ds/coolshop';
import LinearProgress from '@mui/material/LinearProgress';

type ILinearLoaderProps = {
    position?: 'fixed' | 'static' | 'relative' | 'absolute' | 'sticky';
    message?: string;
};

export function LinearLoader({ position = 'fixed', message }: ILinearLoaderProps) {
    return (
        <Stack
            direction="column"
            height={1}
            width={1}
            alignItems="center"
            justifyContent="center"
            position={position}
        >
            <Box width="60px" m="0 auto">
                <LinearProgress />
                {message}
            </Box>
        </Stack>
    );
}
